import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import qs from "query-string";
import LoadingOverlay from "react-loading-overlay";

import ConfirmationModal from "../common/components/ConfirmationModal";
import Portal from "../common/components/Portal";
import CommonActions from "../common/actions";
import ViewModal from "../common/components/ViewModal";
import leaseActions from "./actions";
import Loader from "../common/components/Loader";
import { leaseTableData } from "../../config/tableData";
import {
    addToBreadCrumpData,
    checkPermission,
    findPrevPathFromBreadCrumpData,
    popBreadCrumpData,
    showAlert as showAlertUtil
} from "../../config/utils";
import { getPinnedColumnLeftPositions } from "../../utils/tableUtils";
import imageActions from "../images/actions";
import BuildingLeaseMain from "./components/LeaseMain";
import LeaseInfo from "./components/LeaseInfo";
import projectAction from "../project/actions";
import buildingActions from "../building/actions";
import { flattenObject } from "../../utils/filtersUtils";
import "./lease.css";
import { permissions } from "../../config/permissions";
class BuildingLease extends Component {
    constructor(props) {
        super(props);
        this.pinnedColumnsRef = {};
        this.state = {
            isLoading: true,
            errorMessage: "",
            projectList: [],
            paginationParams: this.props.leaseBuildingReducer?.entityParams.paginationParams,
            showViewModal: false,
            showWildCardFilter: false,
            showAssignConsultancyUsers: false,
            showUploadDataModal: false,
            showMergeOrReplaceModal: false,
            tableLoading: false,
            projectData: {},
            selectedRowId: this.props.leaseBuildingReducer?.entityParams.selectedRowId,
            params: this.props.leaseBuildingReducer?.entityParams.params,
            selectedBuilding: this.props.match.params.id || null,
            selectedLease: this.props.match.params.id || this.props.leaseBuildingReducer?.entityParams.selectedEntity,
            tableData: {
                keys: leaseTableData.keys,
                config: this.props.leaseBuildingReducer?.entityParams.tableConfig || leaseTableData.config
            },
            alertMessage: "",
            wildCardFilterParams: this.props.leaseBuildingReducer?.entityParams.wildCardFilterParams,
            filterParams: this.props.leaseBuildingReducer?.entityParams.filterParams,
            historyPaginationParams: this.props.leaseBuildingReducer?.entityParams.historyPaginationParams,
            historyParams: this.props.leaseBuildingReducer?.entityParams.historyParams,
            logData: {
                count: "",
                data: []
            },
            showConfirmModalLog: false,
            selectedLog: "",
            isRestoreOrDelete: "",
            lineEditingEnabled: false,
            projectId: this.props.leaseBuildingReducer?.entityParams?.projectId
        };
    }

    componentDidMount = async () => {
        const {
            location: { search },
            match: {
                params: { section }
            }
        } = this.props;
        const query = qs.parse(search);
        if (query?.pid || this.props?.match?.params?.id) await this.props.getProjectById(query?.pid ?? this.props?.match?.params?.id);
        const cid = query?.cid || this.props?.clientId || this.props?.projectReducer?.getProjectByIdResponse?.client?.id;
        if (!["add", "edit", "leaseInfo"].includes(section)) {
            await this.props.getLeaseBuildingsDynamicFields({ client_id: cid });
            await this.refreshLeaseList();
        } else {
            this.setState({ isLoading: false });
        }

        if (this.state.projectId !== query?.pid && query?.pid) {
            this.resetEntityParams();
        }
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (
            prevProps.leaseBuildingReducer?.getLeaseDynamicFieldsResponse?.lease_custom_fields !==
            this.props.leaseBuildingReducer?.getLeaseDynamicFieldsResponse?.lease_custom_fields
        ) {
            this.refreshDynamicFields();
        }
    };

    resetEntityParams = async tableData => {
        await this.setState({
            tableData: {
                ...this.state.tableData,
                config: tableData || leaseTableData?.config
            }
        });
        this.updateEntityParams();
    };

    refreshLeaseList = async (hasLoading = true) => {
        this.setState({ isLoading: true });
        const { params, paginationParams, tableData } = this.state;
        let totalCount = 0;
        const hierarchyParam = this.getParams();
        await this.props.getLeaseBuildings({ ...params, ...hierarchyParam });
        const buildingList = this.props.leaseBuildingReducer.getLeaseBuildingsResponse
            ? this.props.leaseBuildingReducer.getLeaseBuildingsResponse.leases || []
            : [];
        totalCount = this.props.leaseBuildingReducer.getLeaseBuildingsResponse
            ? this.props.leaseBuildingReducer.getLeaseBuildingsResponse.count || 0
            : 0;

        if (
            buildingList &&
            !buildingList?.length &&
            this.props.leaseBuildingReducer.getLeaseBuildingsResponse &&
            this.props.leaseBuildingReducer.getLeaseBuildingsResponse.error
        ) {
            await this.setState({ alertMessage: this.props.leaseBuildingReducer.getLeaseBuildingsResponse.error });
            this.showAlert();
        }
        this.setState({
            tableData: {
                ...tableData,
                data: buildingList,
                config: this.props.leaseBuildingReducer.entityParams.tableConfig || tableData.config
            },
            buildingList,
            showWildCardFilter: this.state.params.filters ? true : false,
            paginationParams: {
                ...paginationParams,
                totalCount: totalCount,
                totalPages: Math.ceil(totalCount / paginationParams.perPage)
            },
            isLoading: false
        });
        this.updateEntityParams();
        return true;
    };

    getParams = () => {
        const {
            location: { search: locationSearch },
            match: {
                params: { id, section }
            }
        } = this.props;

        const query = qs.parse(locationSearch);
        let params = {};
        params.client_id = query?.cid || this.props?.clientId || this.props?.projectReducer?.getProjectByIdResponse?.client?.id;
        const projectId = query?.pid;
        if (section === "projectinfo") {
            params.project_id = id;
        } else if (section === "regioninfo") {
            params.region_id = id;
            params.project_id = projectId;
        } else if (section === "siteinfo") {
            params.site_id = id;
            params.project_id = projectId;
        } else if (section === "buildinginfo") {
            params.building_id = id;
            params.project_id = projectId;
        }
        return params;
    };

    refreshDynamicFields = async () => {
        if (this.props.leaseBuildingReducer?.getLeaseDynamicFieldsResponse?.lease_custom_fields) {
            let tempKeys = [...this.state.tableData.keys];
            let tempConfig = this.state.tableData.config;
            const { lease_custom_fields: dynamicBands = {} } = this.props.leaseBuildingReducer?.getLeaseDynamicFieldsResponse;
            Object.entries(dynamicBands).forEach(([band, fields], i) => {
                fields.forEach(field => {
                    let indexToInsertBefore = tempKeys.findIndex(item => item === "created_at");
                    tempKeys.splice(indexToInsertBefore, 0, field?.field_name || "");
                    tempConfig[field?.field_name] = {
                        isVisible:
                            this.props.buildingReducer.entityParams?.tableConfig?.[field?.field_name]?.isVisible === false
                                ? false
                                : field?.rules?.table_default_visible === false
                                ? false
                                : true,
                        label: field?.label,
                        class: "width-230px",
                        searchKey: `dynamic_fields.${field?.field_name}`,
                        type: field?.field_type,
                        hasWildCardSearch: true,
                        hasCommonSearch: false,
                        getListTable: "",
                        commonSearchKey: "dynamic_fields",
                        commonSearchObjectKey: field?.field_name,
                        isDynamicField: true,
                        rules: field?.rules,
                        pinned: this.props.buildingReducer.entityParams?.tableConfig?.[field?.field_name]?.pinned ? true : false,
                        style: this.props.buildingReducer.entityParams?.tableConfig?.[field?.field_name]?.style
                            ? this.props.buildingReducer.entityParams?.tableConfig?.[field?.field_name]?.style
                            : field?.style,
                        hasLineEdit: field?.field_type !== "select" && field?.field_type !== "memo" && field?.field_type !== "boolean" ? true : false
                    };
                });
            });
            tempKeys = [..._.uniq(tempKeys)];
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    keys: tempKeys,
                    config: tempConfig
                },
                initialTableConfig: tempConfig
            });
            this.updateEntityParams(tempConfig);
        }
    };

    getListForCommonFilter = async params => {
        const { search, filters, list } = this.state.params;
        const flattenedList = flattenObject(list);
        params.list = list ? Object.fromEntries(Object.entries(flattenedList)?.filter(([key, value]) => !params.searchKey?.includes(key))) : null;
        const listParams = this.getParams();
        await this.props.getListForCommonFilter({ ...params, ...listParams });
        return this.props.leaseBuildingReducer.getListForCommonFilterResponse?.list || [];
    };

    updateWildCardFilter = async newFilter => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                filters: newFilter
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshLeaseList();
    };

    updateEntityParams = async () => {
        let entityParams = {
            entity: "Lease",
            selectedEntity: this.state.selectedRegion,
            paginationParams: this.state.paginationParams,
            params: this.state.params,
            wildCardFilterParams: this.state.wildCardFilterParams,
            filterParams: this.state.filterParams,
            tableConfig: this.state.tableData.config,
            selectedRowId: this.state.selectedRowId,
            historyPaginationParams: this.state.historyPaginationParams,
            historyParams: this.state.historyParams,
            projectId: this.state.projectId
        };
        await this.props.updateLeaseEntityParams(entityParams);
    };

    resetAllFilters = async () => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 100,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                list: null
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null
        });
        this.updateEntityParams();
        await this.refreshLeaseList();
    };
    resetAll = async () => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 100,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                order: null,
                list: null
            },
            tableData: {
                ...this.state.tableData,
                config: leaseTableData.config
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null
        });
        this.unPinAllColumn();
        this.updateEntityParams();
        await this.refreshLeaseList();
    };

    resetSort = async () => {
        await this.setState({
            params: {
                ...this.state.params,
                order: null
            }
        });
        this.updateEntityParams();
        await this.refreshLeaseList();
    };

    updateCommonFilter = async commonFilters => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                list: commonFilters
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshLeaseList();
    };

    updateTableSortFilters = async searchKey => {
        if (this.state.params.order) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        ...this.state.params.order,
                        [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        this.updateEntityParams();
        await this.refreshLeaseList();
    };

    handleHideColumn = async keyItem => {
        if (keyItem !== "selectAll" && keyItem !== "deselectAll") {
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: {
                        ...this.state.tableData.config,
                        [keyItem]: {
                            ...this.state.tableData.config[keyItem],
                            isVisible: !this.state.tableData.config[keyItem].isVisible
                        }
                    }
                }
            });
        } else {
            let tempConfig = this.state.tableData.config;
            this.state.tableData.keys.forEach(item => {
                if (keyItem === "selectAll") {
                    tempConfig[item].isVisible = true;
                } else {
                    tempConfig[item].isVisible = false;
                }
            });
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: tempConfig
                }
            });
        }
        await this.updateEntityParams();
        return true;
    };

    updateSelectedRow = async rowId => {
        await this.setState({
            selectedRowId: rowId
        });
        await this.updateEntityParams();
    };

    handlePerPageChange = async e => {
        const { paginationParams } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            params: {
                ...this.state.params,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.refreshLeaseList();
    };

    handlePageClick = async page => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                currentPage: page.selected
            },
            params: {
                ...params,
                offset: page.selected + 1
            }
        });
        await this.refreshLeaseList();
    };

    updateCurrentActions = async key => {
        const { currentActions } = this.state;
        await this.setState({
            currentActions: currentActions === key ? null : key
        });
        return true;
    };

    updateCurrentViewAllUsers = async key => {
        const { currentViewAllUsers } = this.state;
        await this.setState({
            currentViewAllUsers: currentViewAllUsers === key ? null : key
        });
        return true;
    };

    showEditPage = async (leaseId, data) => {
        const {
            history,
            location: { search: locationSearch },
            match: {
                params: { id, section }
            },
            basicDetails
        } = this.props;

        this.setState({ selectedLease: leaseId });
        const query = qs.parse(locationSearch);
        const pid = section === "projectinfo" ? id : query?.pid;
        const cid = section !== "leaseInfo" ? basicDetails?.client?.id : query?.cid;

        if (pid) query.pid = pid;
        if (cid) query.cid = cid;

        if (section === "regioninfo") {
            query.region_id = id;
        } else if (section === "siteinfo") {
            query.site_id = id;
            const regionId = basicDetails?.region?.id;
            if (regionId) query.region_id = regionId;
        } else if (section === "buildinginfo") {
            query.bid = id;
            const regionId = basicDetails?.region?.id;
            const siteId = basicDetails?.site?.id;
            if (regionId) query.region_id = regionId;
            if (siteId) query.site_id = siteId;
        }

        const queryString = qs.stringify(query);

        await this.props?.resetReducer();

        addToBreadCrumpData({
            key: "edit",
            name: "Edit Lease",
            path: `/buildingLease/edit/${leaseId}?${queryString}`
        });

        history.push(`/buildingLease/edit/${leaseId}?${queryString}`);
    };

    showAddForm = async () => {
        const {
            match: {
                params: { section, id }
            },
            history,
            location: { search: locationSearch },
            basicDetails
        } = this.props;
        let queryString = "";

        this.setState({ selectedLease: null });

        const query = qs.parse(locationSearch);
        const pid = section === "projectinfo" ? id : query?.pid;
        const cid = basicDetails?.client?.id;
        const queryParts = [];
        if (pid) queryParts.push(`pid=${pid}`);
        if (cid) queryParts.push(`cid=${cid}`);

        if (section === "regioninfo") {
            queryParts.push(`region_id=${id}`);
        } else if (section === "siteinfo") {
            queryParts.push(`site_id=${id}`);
            const regionId = basicDetails?.region?.id;
            if (regionId) queryParts.push(`region_id=${regionId}`);
        } else if (section === "buildinginfo") {
            queryParts.push(`bid=${id}`);
            const regionId = basicDetails?.region?.id;
            const siteId = basicDetails?.site?.id;
            if (regionId) queryParts.push(`region_id=${regionId}`);
            if (siteId) queryParts.push(`site_id=${siteId}`);
        }

        queryString = queryParts?.join("&");
        await this.props?.resetReducer();

        addToBreadCrumpData({
            key: "add",
            name: "Add Lease",
            path: `/buildingLease/add${queryString ? `?${queryString}` : ""}`
        });

        history.push(`/buildingLease/add${queryString ? `?${queryString}` : ""}`);
    };

    showViewModal = () => {
        this.setState({
            showViewModal: true
        });
    };

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    showAlert = () => showAlertUtil(this.state.alertMessage);

    handleDeleteLease = async id => {
        await this.setState({
            showConfirmModal: true,
            selectedLease: id
        });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to delete this Lease?"}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.deleteLeaseOnConfirm}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    deleteLeaseOnConfirm = async () => {
        const { selectedLease } = this.state;
        const { history } = this.props;
        await this.props.deleteBuildingLease(selectedLease);
        if (this.props.leaseBuildingReducer.deleteLeaseBuildingsResponse && this.props.leaseBuildingReducer.deleteLeaseBuildingsResponse.error) {
            await this.setState({ alertMessage: this.props.leaseBuildingReducer.deleteLeaseBuildingsResponse.error });
            this.setState({
                showConfirmModal: false,
                selectedBuilding: null
            });
            this.showAlert();
        } else {
            await this.refreshLeaseList();
            await this.setState({ alertMessage: this?.props?.leaseBuildingReducer?.deleteLeaseBuildingsResponse?.message });
            this.showAlert();
            this.setState({
                showConfirmModal: false,
                selectedBuilding: null
            });
            if (this.props.match.params.tab === "basicdetails") {
                popBreadCrumpData();
                popBreadCrumpData();
                history.push(findPrevPathFromBreadCrumpData() || "/lease");
            }
        }
    };

    handleGlobalSearch = async search => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                search
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        await this.refreshLeaseList();
    };

    showInfoPage = async (leaseId, _, rowData) => {
        const {
            match: {
                params: { section, id }
            },
            history,
            location: { search: locationSearch },
            basicDetails
        } = this.props;
        let queryString = "";

        this.setState({ selectedLease: leaseId });

        const query = qs.parse(locationSearch);
        const pid = section === "projectinfo" ? id : query?.pid;
        const cid = basicDetails?.client?.id;
        const queryParts = [];
        if (pid) queryParts.push(`pid=${pid}`);
        if (cid) queryParts.push(`cid=${cid}`);

        if (section === "regioninfo") {
            queryParts.push(`region_id=${id}`);
        } else if (section === "siteinfo") {
            queryParts.push(`site_id=${id}`);
            const regionId = basicDetails?.region?.id;
            if (regionId) queryParts.push(`region_id=${regionId}`);
        } else if (section === "buildinginfo") {
            queryParts.push(`bid=${id}`);
            const regionId = basicDetails?.region?.id;
            const siteId = basicDetails?.site?.id;
            if (regionId) queryParts.push(`region_id=${regionId}`);
            if (siteId) queryParts.push(`site_id=${siteId}`);
        }
        queryString = queryParts.join("&");
        const path = `/buildingLease/leaseInfo/${rowData?.id}/basicdetails?${queryString}`;
        await this.props?.resetReducer();
        addToBreadCrumpData({
            key: "Name",
            name: rowData.name,
            path
        });
        addToBreadCrumpData({
            key: "info",
            name: "Basic Details",
            path
        });
        this.setState({
            selectedLease: leaseId
        });

        history.push(path);
    };

    handlePerPageChangeHistory = async e => {
        const { historyPaginationParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            historyParams: {
                ...this.state.historyParams,
                offset: 0,
                limit: e.target.value
            }
        });
    };

    handlePageClickHistory = async page => {
        const { historyPaginationParams, historyParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: page.selected
            },
            historyParams: {
                ...historyParams,
                offset: page.selected + 1
            }
        });
    };

    handleGlobalSearchHistory = async search => {
        const { historyParams, historyPaginationParams } = this.state;
        await this.setState({
            historyParams: {
                ...historyParams,
                offset: 0,
                search
            },
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: 0
            }
        });
    };

    handleColumnPin = async keyItem => {
        const { config, keys } = this.state.tableData;
        this.setState({
            isLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        const updatedConfig = {
            ...config,
            [keyItem]: {
                ...config[keyItem],
                pinned: !config[keyItem]?.pinned
            }
        };

        const pinnedColumns = keys.filter(key => updatedConfig[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            },
            projectId: query?.pid,
            isLoading: false
        });
        this.resetEntityParams(updatedConfig);
    };

    unPinAllColumn = () => {
        const { config, keys } = this.state.tableData;
        const updatedConfig = { ...config };
        keys.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                pinned: false,
                style: {
                    ...config[key]?.style,
                    left: "auto"
                }
            };
        });
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            }
        });
    };

    render() {
        const { showWildCardFilter, paginationParams, currentViewAllUsers, showViewModal, tableData, selectedRowId, lineEditingEnabled } = this.state;
        const {
            match: {
                params: { section }
            }
        } = this.props;
        return (
            <LoadingOverlay
                active={this.state.isLoading || this.props?.leaseBuildingReducer?.getLeaseBuildingByIdLoading}
                spinner={<Loader />}
                fadeSpeed={10}
            >
                {section === "add" || section === "edit" || section === "leaseInfo" ? (
                    <LeaseInfo showEditPage={this?.showEditPage} />
                ) : (
                    <BuildingLeaseMain
                        showWildCardFilter={showWildCardFilter}
                        paginationParams={paginationParams}
                        currentViewAllUsers={currentViewAllUsers}
                        showViewModal={this.showViewModal}
                        tableData={tableData}
                        handleGlobalSearch={this.handleGlobalSearch}
                        globalSearchKey={this.state.params.search}
                        updateSelectedRow={this.updateSelectedRow}
                        selectedRowId={selectedRowId}
                        toggleWildCardFilter={this.toggleWildCardFilter}
                        updateCurrentViewAllUsers={this.updateCurrentViewAllUsers}
                        handleDeleteLease={this.handleDeleteLease}
                        showEditPage={this.showEditPage}
                        handlePerPageChange={this.handlePerPageChange}
                        handlePageClick={this.handlePageClick}
                        showAddForm={this.showAddForm}
                        showInfoPage={this.showInfoPage}
                        updateWildCardFilter={this.updateWildCardFilter}
                        wildCardFilter={this.state.params.filters}
                        handleHideColumn={this.handleHideColumn}
                        getListForCommonFilterLease={this.getListForCommonFilter}
                        updateCommonFilter={this.updateCommonFilter}
                        commonFilter={this.state.params.list}
                        resetAllFilters={this.resetAllFilters}
                        resetAll={this.resetAll}
                        updateTableSortFilters={this.updateTableSortFilters}
                        resetSort={this.resetSort}
                        tableParams={this.state.params}
                        tableLoading={this.state.tableLoading}
                        showAddButton={checkPermission("forms", permissions.LEASE_MANAGEMENT, "create")}
                        hasEdit={checkPermission("forms", permissions.LEASE_MANAGEMENT, "edit")}
                        hasDelete={checkPermission("forms", permissions.LEASE_MANAGEMENT, "delete")}
                        hasInfoPage={checkPermission("forms", permissions.LEASE_MANAGEMENT, "view")}
                        entity="lease"
                        lineEditingEnabled={lineEditingEnabled}
                        handleColumnPin={this.handleColumnPin}
                        pinnedColumnsRef={this.pinnedColumnsRef}
                        unPinAllColumn={this.unPinAllColumn}
                        hasViewIcon={checkPermission("forms", permissions.LEASE_MANAGEMENT, "view")}
                    />
                )}
                {this.renderConfirmationModal()}
                {showViewModal ? (
                    <Portal
                        body={
                            <ViewModal
                                keys={tableData.keys}
                                config={tableData.config}
                                handleHideColumn={this.handleHideColumn}
                                onCancel={() => this.setState({ showViewModal: false })}
                            />
                        }
                        onCancel={() => this.setState({ showViewModal: false })}
                    />
                ) : null}
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    const {
        commonReducer,
        leaseBuildingReducer,
        dashboardReducer,
        buildingReducer,
        imageReducer: { tradeList },
        projectReducer
    } = state;
    return { commonReducer, leaseBuildingReducer, dashboardReducer, tradeList, buildingReducer, projectReducer };
};
const { getTradeList } = imageActions;
export default withRouter(
    connect(mapStateToProps, {
        ...leaseActions,
        ...CommonActions,
        ...projectAction,
        ...buildingActions,
        getTradeList
    })(BuildingLease)
);
